(() => {
  if (window.BMLandingPageInitialized) return;
  window.BMLandingPageInitialized = true;

  const syncProductForm = (select) => {
    const landing = select.closest('[data-bm-lp]');
    if (!landing) return;
    const option = select.options[select.selectedIndex];
    if (!option) return;

    const available = option.dataset.available === 'true';
    landing.querySelectorAll('[data-bm-lp-price]').forEach((price) => {
      price.textContent = option.dataset.price;
    });
    landing.querySelectorAll('[data-bm-lp-add]').forEach((button) => {
      button.disabled = !available;
      button.textContent = available ? button.dataset.bmLpDefaultLabel || 'Add to cart' : 'Sold out';
    });
    landing.querySelectorAll('[data-bm-lp-variant-id]').forEach((input) => {
      input.value = option.value;
    });
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-bm-lp-variant]')) syncProductForm(event.target);
  });

  document.querySelectorAll('[data-bm-lp-variant]').forEach(syncProductForm);

  let activeZoomTrigger = null;

  document.addEventListener('click', (event) => {
    const zoomTrigger = event.target.closest('[data-bm-lp-zoom]');
    if (zoomTrigger) {
      const landing = zoomTrigger.closest('[data-bm-lp]');
      const lightbox = landing && landing.querySelector('[data-bm-lp-lightbox]');
      const image = lightbox && lightbox.querySelector('[data-bm-lp-lightbox-image]');
      const caption = lightbox && lightbox.querySelector('[data-bm-lp-lightbox-caption]');
      if (!lightbox || !image || !caption) return;

      activeZoomTrigger = zoomTrigger;
      image.src = zoomTrigger.dataset.bmLpZoomSrc;
      image.alt = zoomTrigger.dataset.bmLpZoomAlt || '';
      caption.textContent = zoomTrigger.dataset.bmLpZoomCaption || '';
      if (typeof lightbox.showModal === 'function') lightbox.showModal();
      else lightbox.setAttribute('open', '');
      return;
    }

    const closeButton = event.target.closest('[data-bm-lp-lightbox-close]');
    const lightbox = closeButton && closeButton.closest('[data-bm-lp-lightbox]');
    if (lightbox) lightbox.close();
  });

  document.querySelectorAll('[data-bm-lp-lightbox]').forEach((lightbox) => {
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });
    lightbox.addEventListener('close', () => {
      const image = lightbox.querySelector('[data-bm-lp-lightbox-image]');
      if (image) image.removeAttribute('src');
      if (activeZoomTrigger) activeZoomTrigger.focus();
      activeZoomTrigger = null;
    });
  });

})();
